import type { AccountDetailPayload, AccountMetricView } from '../account-detail.model';
import { formatAccountBalanceExact, formatAccountDate } from '../accounts-display';
import { mapSpendingSummary } from './spending-summary';

function autoSavingsLabel(status: unknown): string {
  if (typeof status !== 'string' || !status.trim()) {
    return 'n/a';
  }
  return status.trim().toLowerCase() === 'active' ? 'On' : 'Off';
}

export function mapSavingsSummary(payload: AccountDetailPayload): {
  metrics: AccountMetricView[];
  linkedAccounts: ReturnType<typeof mapSpendingSummary>['linkedAccounts'];
} {
  const schedule = payload.fundsSource?.autoSaveSchedule;
  const amount =
    schedule?.status?.toLowerCase() === 'notstarted' || schedule?.nextDepositAmount === undefined
      ? 'n/a'
      : formatAccountBalanceExact(schedule.nextDepositAmount);
  const nextDate = formatAccountDate(schedule?.nextDepositDate ?? payload.fundsSource?.nextAvailableDate);
  return {
    metrics: [
      { label: 'Available balance', value: formatAccountBalanceExact(payload.balance) },
      { label: 'Auto-savings', value: autoSavingsLabel(schedule?.status) },
      { label: 'Auto-save amount', value: amount },
      { label: 'Next date', value: nextDate },
    ],
    linkedAccounts: mapSpendingSummary(payload).linkedAccounts,
  };
}
